import { useQuery } from "react-query";
import { ChampionshipGenderAPI } from "api/admin/championshipGender";
import { CHAMPIONSHIP_GENDERS } from "helpers/constants";

export default function useChampionshipGenders(championshipId) {
  return useQuery([CHAMPIONSHIP_GENDERS, championshipId], () =>
    ChampionshipGenderAPI.getAll(championshipId)
  );
}
